import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import SomatorioHorasExtrasMOTCStore from "../stores/SomatorioHorasExtrasMOTCStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {Row, Col} from 'reactstrap';
import {CustomBarChart} from "../../comum/components/CustomBarChart";

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'CARGO', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'AR_DEBITO'];

@inject("store")
@DataWrapper
@observer
export class SomatorioHorasExtrasMOTC extends Component {
    constructor(props) {
        super(props);
        this.controller = new SomatorioHorasExtrasMOTCStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Somatório de horas extras da MOT por Unidade de negócio (BU)");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                location={this.props.location}
                                controller={this.controller}
                                fields={FILTROS} />
                        <Row>
                            <Col xs={12} md={12} lg={10}>
                                <CustomBarChart stackId="1" dataKeys={this.controller.produtos} data={this.controller.dados}
                                        labelAxisX={"Unidade de negócio (BU)"} labelAxisY={"Quantidade"} />
                            </Col>
                        </Row>
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
